import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./IECSelectionPage.module.css";

// Import logos for each IEC firm
import aLeagueLogo from "../../imgs/iec-assets/aleague-logo.png";

// IEC firm data
const iecFirms = [
    {
        id: "aleague",
        name: "A. League Consulting",
        logo: aLeagueLogo,
        location: "Taipei, TW",
        path: "/iec/a-league",
    },
];

function IECTile({ id, name, logo, location, path }) {
    const navigate = useNavigate();

    const handleTileClick = () => {
        navigate(path);
    };

    return (
        <div className={styles.tile} onClick={handleTileClick}>
            <div className={styles.logo_container}>
                <img src={logo} alt={`${name} logo`} className={styles.logo} />
            </div>
            <div className={styles.tile_content}>
                <h3 className={styles.name}>{name}</h3>
                <p className={styles.location}>📍 {location}</p>
                <button className={styles.action_button}>{id === "aleague" ? "View Profile" : "Coming Soon"}</button>
            </div>
        </div>
    );
}

export default function IECSelectionPage() {
    return (
        <div className={styles.page_wrapper}>
            <div className={styles.page_container}>
                <div className={styles.page_header}>
                    <h1 className={styles.page_title}>Talk to a Human</h1>
                    <p className={styles.page_subtitle}>
                        All the college consulting firms below have been vetted by the Athena team. We can vouch for
                        their quality, and they do not pay to be featured in the list below.
                    </p>
                </div>

                <div className={styles.tiles_container}>
                    {iecFirms.map((firm) => (
                        <IECTile key={firm.id} {...firm} />
                    ))}
                </div>
            </div>
        </div>
    );
}
